function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    const currentDetails = event.currentTarget.closest("details");
    const parent = currentDetails.parentElement;
    parent.querySelectorAll("details").forEach((details) => {
      if (details !== currentDetails) {
        details.removeAttribute("open");
        const summary = details.querySelector("summary");
        if (summary) {
          summary.setAttribute("aria-expanded", false);
        }
      }
    });
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("p80-header-main__nav-list")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

// Detect sticky header state with debounced class toggling
(function () {
  const header = document.querySelector(".p80-header");
  const decoyMenu = header.querySelector(".p80-header-decoy__nav-menu");
  const topMenu = header.querySelector(".p80-header-top__nav-menu");
  const mainMenu = header.querySelector(".p80-header-main__nav-nav");

  if (!header) {
    console.warn("Header element not found");
    return;
  }

  let ticking = false;
  let debounceTimer = null;
  let currentState = null; // Track current state to avoid unnecessary DOM operations

  const SCROLL_THRESHOLD = 20;
  const DEBOUNCE_DELAY = 50; // Delay in milliseconds before applying class change

  // Apply the sticky state with debounce
  function applyState(shouldBeStuck) {
    // Clear any pending debounce
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    // Debounce the class toggle
    debounceTimer = setTimeout(() => {
      // Only update if state actually changed
      if (currentState !== shouldBeStuck) {
        if (shouldBeStuck) {
          header.classList.add("is-stuck");
          decoyMenu.querySelectorAll("button").forEach((link) => {
            link.removeAttribute("tabindex");
          });
          topMenu.querySelectorAll("a").forEach((link) => {
            link.setAttribute("tabindex", "-1");
          });
          topMenu.querySelectorAll("button").forEach((link) => {
            link.setAttribute("tabindex", "-1");
          });
          mainMenu.querySelectorAll("a").forEach((link) => {
            link.setAttribute("tabindex", "-1");
          });
        } else {
          header.classList.remove("is-stuck");
          decoyMenu.querySelectorAll("button").forEach((link) => {
            link.setAttribute("tabindex", "-1");
          });
          topMenu.querySelectorAll("a").forEach((link) => {
            link.removeAttribute("tabindex");
          });
          topMenu.querySelectorAll("button").forEach((link) => {
            link.removeAttribute("tabindex");
          });
          mainMenu.querySelectorAll("a").forEach((link) => {
            link.removeAttribute("tabindex");
          });
          const morePopoverEl = decoyMenu.querySelector(
            ".p80-header-main__more-submenu",
          );
          if (morePopoverEl) morePopoverEl.hidePopover();
        }
        currentState = shouldBeStuck;
      }
    }, DEBOUNCE_DELAY);
  }

  // Check scroll position and determine state
  function checkScroll() {
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop;
    const shouldBeStuck = scrollPos > SCROLL_THRESHOLD;

    applyState(shouldBeStuck);
    ticking = false;
  }

  // Throttle scroll events for performance
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(checkScroll);
      ticking = true;
    }
  }

  // Initialize - set initial state without debounce
  const initialScrollPos =
    window.pageYOffset || document.documentElement.scrollTop;
  currentState = initialScrollPos > SCROLL_THRESHOLD;
  if (currentState) {
    header.classList.add("is-stuck");
  }

  // Listen for scroll
  window.addEventListener("scroll", onScroll, { passive: true });

  // Optional: Clean up on page unload
  window.addEventListener("beforeunload", () => {
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const headerEl = document.querySelector(".p80-header");
  // Get all elements with data-decoy-menu attribute
  const decoyMenus = document.querySelectorAll("[data-decoy-menu]");

  decoyMenus.forEach(function (decoyMenu) {
    decoyMenu.addEventListener("click", function (e) {
      const targetValue = this.getAttribute("data-target");
      let summaryElement = null;

      if (targetValue !== "more") {
        console.log("more is clicked");
        e.preventDefault(); // Prevent default anchor behavior
        // Find and click the summary element with matching aria-controls
        summaryElement = headerEl.querySelector(
          `summary[aria-controls="${targetValue}"]`,
        );
      }
      if (summaryElement) {
        summaryElement.click();
        const detailsElement = summaryElement.parentElement;

        detailsElement
          .querySelector(".p80-header-main__mega-menu")
          .querySelectorAll("a")
          .forEach((elem) => {
            elem.removeAttribute("tabindex");
          });

        // Wait for the details to open (if it's a <details> element)
        setTimeout(() => {
          // Find first focusable element inside
          const focusable = detailsElement.querySelector(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
          );

          if (focusable) {
            focusable.focus();
          }
        }, 0);
      }
    });
  });
});

// Initialize slider functionality
function initTopBarSlider() {
  const container = document.querySelector(".p80-header__top-bar-text");
  const storeId = GetSelectedStoreId();
  if (!container) return;

  let currentSlide = 0;
  let slides = [];
  let navButtons = null;

  // Check for AnnouncementsJSON script and update announcements if store matches
  const script = document.querySelector("script#AnnouncementsJSON");
  if (script) {
    try {
      const announcementJson = JSON.parse(script.textContent.trim());
      const announcement = announcementJson.find(
        (obj) => obj.store_id == storeId,
      );
      if (announcement) {
        const ann1El = container.querySelector("[data-announcement-1]");
        if (ann1El) ann1El.innerHTML = announcement.announcement_1;
        const ann2El = container.querySelector("[data-announcement-2]");
        if (ann2El) ann2El.innerHTML = announcement.announcement_2;
      }
    } catch (e) {
      console.error("Error parsing AnnouncementsJSON:", e);
    }
  }

  function createNavigationButtons() {
    // Check if buttons already exist
    if (container.querySelector(".p80-header__top-bar-slider-nav")) return;

    const prevBtn = document.createElement("button");
    prevBtn.className = "p80-header__top-bar-slider-nav prev";
    prevBtn.setAttribute("aria-label", "Previous message");

    const nextBtn = document.createElement("button");
    nextBtn.className = "p80-header__top-bar-slider-nav next";
    nextBtn.setAttribute("aria-label", "Next message");

    container.appendChild(prevBtn);
    container.appendChild(nextBtn);

    prevBtn.addEventListener("click", () => navigate(-1));
    nextBtn.addEventListener("click", () => navigate(1));

    navButtons = { prev: prevBtn, next: nextBtn };
  }

  function updateSlides() {
    slides = Array.from(
      container.querySelectorAll(
        ":scope > div:not(.p80-header__top-bar-slider-nav, :empty)",
      ),
    );

    if (slides.length === 0) return;

    // Remove active class from all slides
    slides.forEach((slide) =>
      slide.classList.remove("p80-header__top-bar-active"),
    );

    // Add active class to current slide
    if (slides[currentSlide]) {
      slides[currentSlide].classList.add("p80-header__top-bar-active");
    }
  }

  function navigate(direction) {
    currentSlide += direction;

    // Loop around
    if (currentSlide >= slides.length) {
      currentSlide = 0;
    } else if (currentSlide < 0) {
      currentSlide = slides.length - 1;
    }

    updateSlides();
  }

  function checkScreenSize() {
    const isMobile = window.innerWidth <= 1169;

    if (isMobile) {
      createNavigationButtons();
      updateSlides();
    } else {
      // Remove active class on desktop to show all items
      slides.forEach((slide) =>
        slide.classList.remove("p80-header__top-bar-active"),
      );
    }
  }

  // Initialize
  slides = Array.from(container.querySelectorAll(":scope > div:not(:empty)"));

  createNavigationButtons();

  // Set first slide as active on init
  if (slides.length > 1 && window.innerWidth <= 1169) {
    slides[0].classList.add("p80-header__top-bar-active");
  }

  checkScreenSize();

  // Update on window resize
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkScreenSize, 250);
  });

  // Optional: Auto-advance slider every 5 seconds on mobile
  setInterval(() => {
    if (window.innerWidth <= 1169) {
      navigate(1);
    }
  }, 5000);
}

// Run when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTopBarSlider);
} else {
  initTopBarSlider();
}

document.addEventListener("DOMContentLoaded", () => {
  // Get DOM elements
  const headerEl = document.querySelector(".p80-header");
  const openBtn = headerEl.querySelector("button.header__mobile-search-open");
  const closeBtn = headerEl.querySelector("button.header__mobile-search-close");
  const searchDiv = headerEl.querySelector("div.p80-header-main__search");
  const headerNavEl = headerEl.querySelector(".p80-header-main__nav-nav");
  const headerMainContEl = headerEl.querySelector(
    ".p80-header-main>.container",
  );
  const topNavEl = headerMainContEl.querySelector(".p80-header-top__nav-menu");
  const decoyNavEl = headerMainContEl.querySelector(
    ".p80-header-decoy__nav-menu",
  );

  // Function to set nav widths as CSS custom properties
  function setNavWidths() {
    const extraPadding = window.innerWidth >= 1200 ? 24 : 16;
    if (topNavEl) {
      // Calculate width based on immediate li children with padding per item
      const liElements = topNavEl.querySelectorAll(":scope > li");
      let totalWidth = 0;
      liElements.forEach((li) => {
        totalWidth += li.offsetWidth + extraPadding;
      });
      const topNavWidth = totalWidth + "px";
      headerMainContEl.style.setProperty("--top-nav-width", topNavWidth);
    }
    if (decoyNavEl) {
      // Calculate width based on immediate li children with padding per item, excluding hidden-li
      const liElementsDecoy = decoyNavEl.querySelectorAll(":scope > li");
      let totalWidthDecoy = 0;
      liElementsDecoy.forEach((li) => {
        if (!li.classList.contains("hidden-li")) {
          totalWidthDecoy += li.offsetWidth + extraPadding;
        }
      });
      const decoyNavWidth = totalWidthDecoy + "px";
      headerMainContEl.style.setProperty("--decoy-nav-width", decoyNavWidth);
    }
  }

  // Function to remove 'open' class
  function closeSearch() {
    if (searchDiv) {
      searchDiv.classList.remove("open");
    }
  }

  // Update widths and viewport on resize
  function handleResize() {
    checkViewport();
    setNavWidths();
    setHeaderHeight();
    setMegaMenuMaxHeight();
  }

  // Function to set header height as CSS custom property
  function setHeaderHeight() {
    if (headerEl && headerNavEl) {
      const diff = headerEl.offsetHeight - headerNavEl.offsetHeight;
      headerEl.style.setProperty("--headerHeight", diff + "px");
    }
  }

  // Function to set max-height on mega menus based on viewport height minus header height
  function setMegaMenuMaxHeight() {
    const megaMenus = document.querySelectorAll(".p80-header-main__mega-menu");
    const maxHeight = window.innerHeight - headerEl.offsetHeight + "px";
    megaMenus.forEach((menu) => {
      menu.style.setProperty("--max-height", maxHeight);
    });
  }

  // Add click event to open button
  if (openBtn && searchDiv) {
    openBtn.addEventListener("click", () => {
      searchDiv.classList.add("open");
      setTimeout(() => searchDiv.querySelector('[name="q"]')?.focus(), 50);
    });
  }

  // Add click event to close button
  if (closeBtn && searchDiv) {
    closeBtn.addEventListener("click", closeSearch);
  }

  // Remove 'open' class when viewport is above 1100px
  function checkViewport() {
    if (window.innerWidth > 1100) {
      closeSearch();
    }
  }

  // Check on window resize
  window.addEventListener("resize", handleResize);

  // Initial check on page load
  checkViewport();
  setNavWidths();
  setHeaderHeight();
  setMegaMenuMaxHeight();
});

const focusableSelectors =
  'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]';

function getNextFocusable(current) {
  const focusables = Array.from(document.querySelectorAll(focusableSelectors));
  const index = focusables.indexOf(current);
  if (index === -1) return focusables[0];
  return focusables[(index + 1) % focusables.length];
}

// Add event listener on Escape key press
window.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    // handle megamenu while header is sticky
    const activeMMEl = document.querySelector(
      ".p80-header-main__nav-dropdown[open]",
    );
    if (activeMMEl) {
      const decoyMMEl = document.querySelector(".p80-header-decoy__nav-menu");
      const prevLinkId = activeMMEl
        .querySelector("summary")
        .getAttribute("aria-controls");

      if (decoyMMEl.querySelector(`[data-target="${prevLinkId}"]`))
        decoyMMEl.querySelector(`[data-target="${prevLinkId}"]`).focus();

      document
        .querySelector(".p80-header-main__nav-nav")
        .querySelectorAll("a")
        .forEach((elem) => {
          elem.setAttribute("tabindex", "-1");
        });
    }

    document.body.click();

    // Close any open mega menu first
    const megaMenuItemEl = document.querySelector(
      '.p80-header-main__nav-link[aria-expanded="true"]',
    );
    if (megaMenuItemEl) {
      megaMenuItemEl.click();
    }

    const closeMMEl = document.querySelector("#close-mobile-menu");
    if (closeMMEl) closeMMEl.click();

    const searchMMEl = document.querySelector(".p80-header-main__search.open");
    if (searchMMEl) searchMMEl.classList.remove("open");
  }
});

// Accessible Dropdown Menu with Focus Trap
document.addEventListener("DOMContentLoaded", () => {
  const dropdownButtons = document.querySelectorAll(
    ".p80-header-top__nav-item button",
  );

  dropdownButtons.forEach((button) => {
    const navItem = button.closest(".p80-header-top__nav-item");
    const dropdown = navItem.querySelector(".p80-header-main__dropdown-menu");

    if (!dropdown) return;

    const dropdownLinks = dropdown.querySelectorAll("a");
    let isOpen = false;

    // Close dropdown
    const closeDropdown = (returnFocus = false) => {
      isOpen = false;
      button.setAttribute("aria-expanded", "false");

      // Make dropdown links unfocusable when closed
      dropdownLinks.forEach((link) => {
        link.setAttribute("tabindex", "-1");
      });

      if (returnFocus) {
        button.focus();
      }
    };

    // Open dropdown
    const openDropdown = () => {
      isOpen = true;
      button.setAttribute("aria-expanded", "true");

      // Make dropdown links focusable when open
      dropdownLinks.forEach((link) => {
        link.setAttribute("tabindex", "0");
      });
    };

    // Button click handler
    button.addEventListener("click", (e) => {
      e.preventDefault();
      if (isOpen) {
        closeDropdown();
      } else {
        openDropdown();
      }
    });

    // Button keyboard handler
    button.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (!isOpen) {
          openDropdown();
        }
      } else if (e.key === "ArrowDown" && !isOpen) {
        e.preventDefault();
        openDropdown();
      } else if (e.key === "Escape" && isOpen) {
        // e.preventDefault();
        closeDropdown(true);
      }
    });

    // Handle focus entering dropdown
    button.addEventListener("focus", () => {
      if (!isOpen) {
        openDropdown();
      }
    });

    // Dropdown keyboard navigation
    dropdown.addEventListener("keydown", (e) => {
      const currentIndex = Array.from(dropdownLinks).indexOf(
        document.activeElement,
      );

      if (e.key === "Escape") {
        e.preventDefault();
        closeDropdown(true);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        const nextIndex = (currentIndex + 1) % dropdownLinks.length;
        dropdownLinks[nextIndex].focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        const prevIndex =
          currentIndex <= 0 ? dropdownLinks.length - 1 : currentIndex - 1;
        dropdownLinks[prevIndex].focus();
      } else if (e.key === "Home") {
        e.preventDefault();
        dropdownLinks[0].focus();
      } else if (e.key === "End") {
        e.preventDefault();
        dropdownLinks[dropdownLinks.length - 1].focus();
      } else if (e.key === "Tab") {
        // Allow natural tab behavior, but close on last item
        if (!e.shiftKey && currentIndex === dropdownLinks.length - 1) {
          closeDropdown();
        } else if (e.shiftKey && currentIndex === 0) {
          // Tabbing backwards from first item goes back to button
          e.preventDefault();
          closeDropdown(true);
        }
      }
    });

    // Close when focus leaves the nav item entirely
    navItem.addEventListener("focusout", (e) => {
      // Check if focus is moving outside the nav item
      setTimeout(() => {
        if (!navItem.contains(document.activeElement)) {
          closeDropdown();
        }
      }, 0);
    });

    // Close on click outside
    document.addEventListener("click", (e) => {
      if (!navItem.contains(e.target)) {
        closeDropdown();
      }
    });

    // Close on mouse leave (for mouse users)
    navItem.addEventListener("mouseleave", () => {
      // Only close if not focused
      if (!navItem.contains(document.activeElement)) {
        closeDropdown();
      }
    });
  });
});
